"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const org_transcrypt___runtime___js_1 = require("./org.transcrypt.__runtime__.js");
var __name__ = 'tfchain.encoding.errors';
exports.IntegerOutOfRange = org_transcrypt___runtime___js_1.__class__('IntegerOutOfRange', [org_transcrypt___runtime___js_1.Exception], {
    __module__: __name__,
});
exports.SliceLengthOutOfRange = org_transcrypt___runtime___js_1.__class__('SliceLengthOutOfRange', [org_transcrypt___runtime___js_1.Exception], {
    __module__: __name__,
});
//# sourceMappingURL=tfchain.encoding.errors.map
//# sourceMappingURL=tfchain.encoding.errors.js.map